<template>
  <!--subPage -->
  <div class="subPage_container" :class="{ isModalOpen: clickApi }">
    <!--서비스연결 약관:start-->
    <div class="agree_wrap">
        <h5>{{ $t('mypage.caution') }}</h5>
        <p class="info">{{ $t('mypage.cautionContent1') }}</p>
        <input type="checkbox" id="agreeChk01" name="agree_Chk" v-model="chkState['agreeChk01']"><label for="agreeChk01">{{ $t('mypage.cautionContent2') }}</label>
        <input type="checkbox" id="agreeChk02" name="agree_Chk" v-model="chkState['agreeChk02']"><label for="agreeChk02">{{ $t('mypage.cautionContent3') }}</label>
        <input type="checkbox" id="agreeChk03" name="agree_Chk" v-model="chkState['agreeChk03']"><label for="agreeChk03">{{ $t('mypage.cautionContent4') }}</label>
        <input type="checkbox" id="agreeChk04" name="agree_Chk" v-model="chkState['agreeChk04']"><label for="agreeChk04">{{ $t('mypage.cautionContent5') }}</label>
        <input type="checkbox" id="agreeChk05" name="agree_Chk" v-model="chkState['agreeChk05']"><label for="agreeChk05">{{ $t('mypage.cautionContent6') }}</label>
        <input type="checkbox" id="agreeChk06" name="agree_Chk" v-model="chkState['agreeChk06']"><label for="agreeChk06">{{ $t('mypage.cautionContent7') }}</label>
    </div>
    <!--서비스연결 약관:End-->

    <!--//subPage_container :End -->

    <!--//등록버튼-->
    <div class="btn_bottom_wrap2">
      <div class="agreeChk">
        <input
          type="checkbox"
          id="agreeChkAll"
          name="agreeChkAll"
          v-model="chkState['agreeChkAll']"
        /><label for="agreeChkAll"
          >{{ $t('mypage.agreeAll') }}
        </label>
      </div>
      <a
        class="btn_primary nextStep"
        :class="{ light: !allCheckedClass }"
        @click="changeApiState"
      >
        {{ $t('mypage.next') }}
      </a>
    </div>
  </div>
  <!--//subPage :End -->
</template>

<script>
import { popupControll } from "@/utils/modalText";
import { mapState, mapMutations } from "vuex";

export default {
  name: "AgreeApi",
  computed: {
    ...mapState("user", ["clickApi"]),
    allCheckedClass(){
      for(let key in this.chkState) {
        if(!this.chkState[key]) { // 하나라도 false인 경우
          return false
        }
      }
      return true;
    }
  },
  data() {
    return {
      chkState:{
        agreeChk01: false,
        agreeChk02: false,
        agreeChk03: false,
        agreeChk04: false,
        agreeChk05: false,
        agreeChk06: false,
        agreeChkAll: false, // 전체 동의 체크박스
      },
      allCheckedStatus:true,
    }
  },
  methods: {
    ...mapMutations("user", ["changeApi"]),
    changeApiState(event) {
      // 모든 체크박스가 체크되었는지 확인
      for(let key in this.chkState) {
        if(!this.chkState[key]) { // 하나라도 false인 경우
          this.allCheckedStatus = false;
          break; // 더 이상 확인할 필요가 없으므로 반복문 종료
        }else{
          this.allCheckedStatus = true;
        }
      }
      if (!this.allCheckedStatus) {
        // 모든 체크박스가 체크되지 않았다면, 사용자에게 알림
        event.preventDefault();
        popupControll(this.$t('mypage.needAgreeAll'));
        return;
      } else {
        // 모든 체크박스가 체크되었다면, API 상태 변경
        this.changeApi({ state: true });
      }
    },
  },
};
</script>

<style>
.disabled {
  pointer-events: none;
  background: #343a46 !important;
  color: #5b6573 !important;
}
</style>
